import { z } from "zod";
import { ApiError, payloadDetailCode } from "./api";

/** api_reference spec, "Customer-facing text is Spanish and names no
 * implementation detail before any reader sees it": one finding of the backend's
 * customer-text check, as an administrator payload carries it. */
export const textFindingSchema = z.object({
  kind: z.enum(["internal_reference", "not_spanish"]),
  excerpt: z.string(),
});
export type TextFinding = z.infer<typeof textFindingSchema>;
/** A findings list that a public payload and an older server do not send at all; read it as `?? []`. */
export const textFindingsSchema = z.array(textFindingSchema).optional();

/** The finding in Spanish, for an administrator. */
export function describeFinding(finding: TextFinding): string {
  return finding.kind === "internal_reference"
    ? `menciona detalles internos («${finding.excerpt}»)`
    : `no está en español («${finding.excerpt}»)`;
}

/** The drawer's reason for an item hidden from readers: names the first finding. */
export function withheldReason(findings: readonly TextFinding[]): string {
  const [first] = findings;
  return first
    ? `Se oculta a los lectores: ${describeFinding(first)}.`
    : "Se oculta a los lectores.";
}

const rejectionSchema = z.object({
  detail: z.object({ findings: z.array(textFindingSchema).catch([]) }),
});

/** The findings of a `customer_text_rejected` refusal, or `null` when the error
 * is anything else. A malformed findings list is read as empty. */
export function customerTextRejection(error: unknown): TextFinding[] | null {
  if (!(error instanceof ApiError) || error.status !== 422) return null;
  if (payloadDetailCode(error.payload) !== "customer_text_rejected") return null;
  const parsed = rejectionSchema.safeParse(error.payload);
  return parsed.success ? parsed.data.detail.findings : [];
}
